import { fork, put, takeLatest } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import { actions as alertActions } from "../alerts";
import { fetchStockVoteRoutine, toggleStockVoteRoutine } from "./index";

function* onFetchStockVoteTrigger({ payload }) {
  yield put(fetchStockVoteRoutine.request(payload));
}

function* onFetchStockVote({ payload }) {
  const { stockId } = payload;

  try {
    const { data } = yield ApiClient.get({
      urlPath: "app.stocks.vote",
      variables: { stockId }
    });

    yield put(
      fetchStockVoteRoutine.success({
        stockId,
        voted: Boolean(data?.voted),
        weekStartDate: data?.week_start_date ?? null
      })
    );
  } catch (error) {
    yield put(fetchStockVoteRoutine.failure({ stockId, error }));
  }
}

function* onToggleStockVoteTrigger({ payload }) {
  yield put(toggleStockVoteRoutine.request(payload));
}

function* onToggleStockVote({ payload }) {
  const { stockId } = payload;

  try {
    const { data } = yield ApiClient.post({
      urlPath: "app.stocks.toggleVote",
      variables: { stockId }
    });

    const voted = Boolean(data?.voted);

    yield put(
      toggleStockVoteRoutine.success({
        stockId,
        voted,
        weekStartDate: data?.week_start_date ?? null
      })
    );

    if (voted) {
      yield put(
        alertActions.addSuccessAlert({
          title: "Vote added successfully"
        })
      );
    }
  } catch (error) {
    yield put(toggleStockVoteRoutine.failure({ stockId, error }));
  }
}

function* watchVoting() {
  yield takeLatest(fetchStockVoteRoutine.TRIGGER, onFetchStockVoteTrigger);
  yield takeLatest(fetchStockVoteRoutine.REQUEST, onFetchStockVote);
  yield takeLatest(toggleStockVoteRoutine.TRIGGER, onToggleStockVoteTrigger);
  yield takeLatest(toggleStockVoteRoutine.REQUEST, onToggleStockVote);
}

export default [fork(watchVoting)];
